/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line


document.addEventListener('DOMContentLoaded', () => {
  const observer = new MutationObserver(muts => {
    muts.forEach(m => {
      m.addedNodes.forEach(node => {
        if (node.nodeName === 'VIDEO') {
          node.removeAttribute('controls');
        }
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
});
 

document.addEventListener('DOMContentLoaded', () => {
  console.log('DOM fully loaded');

  const supportedPageIds = [
    'hydrafacial-montreal-beauties-lab',
    'extraction-signature-express-beauties-lab',
    'longevity-signature-facial-beauties-lab',
    'personalized-self-love-facial-beauties-lab',
    'express-facial-beauties-lab',
    'biologique-recherche-restructuring-and-smoothing-facial-beauties-lab',
    'biologique-recherche-lift-c-v-s-facial-treatment-beauties-lab',
    'biologique-recherche-seconde-peau-facial-beauties-lab'
  ];

  const currentId = document.body.id;

  if (!supportedPageIds.includes(currentId)) {
    console.log('Body ID not in supported pages, current:', currentId);
    return;
  }

  const productComponent = document.querySelector('product-component');
  if (!productComponent) {
    console.log('No <product-component> found');
    return;
  }

  // Original autoplay on page load, your old working code:
  const deferredMediaButton = productComponent.querySelector('deferred-media > button.deferred-media__poster');
  if (deferredMediaButton) {
    const scrollPos = window.scrollY;   // save current scroll
    deferredMediaButton.click();
    window.scrollTo(0, scrollPos);      // restore scroll

    const deferredMediaVideo = productComponent.querySelector('deferred-media > video');
    if (deferredMediaVideo) {
      deferredMediaVideo.muted = true;

      deferredMediaVideo.addEventListener('canplay', () => {
        console.log('Video can play, attempting to play');
        deferredMediaVideo.play().then(() => {
          console.log('Video is playing');
        }).catch(err => {
          console.warn('Play attempt failed:', err);
        });
      });
    } else {
      console.log('No <video> found inside <deferred-media>');
    }
  } else {
    console.log('No deferred-media poster button found inside <product-component>');
  }

  // New: autoplay on thumbnail click
  document.querySelectorAll('.product__thumb a').forEach(thumb => {
    thumb.addEventListener('click', () => {
      setTimeout(() => {
        const activeSlide = document.querySelector('.product__slide.media--active');
        if (!activeSlide) {
          console.log('No active slide found after thumb click');
          return;
        }

        if (activeSlide.dataset.type === 'video') {
          const deferredMedia = activeSlide.querySelector('deferred-media');
          if (!deferredMedia) {
            console.log('No deferred-media found in active slide after thumb click');
            return;
          }

          const posterButton = deferredMedia.querySelector('button.deferred-media__poster');
          if (posterButton) {
            posterButton.click();
          }

          const video = deferredMedia.querySelector('video');
          if (video) {
            video.removeAttribute('controls');
            video.muted = true;
            video.play().catch(err => {
              console.warn('Play failed after thumb click:', err);
            });
          }
        } else {
          console.log('Active slide after thumb click is not video');
        }
      }, 100);
    });
  });
});




document.addEventListener('DOMContentLoaded', () => {
  const hash = window.location.hash;

  if (!hash) return; // no anchor, nothing to do

  // Function to scroll to the target element
  const scrollToAnchor = () => {
    const target = document.querySelector(hash);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      target.focus({ preventScroll: true });
      return true;
    }
    return false;
  };

  // Try immediately
  if (!scrollToAnchor()) {
    // If element isn't ready yet, retry until it exists
    const interval = setInterval(() => {
      if (scrollToAnchor()) clearInterval(interval);
    }, 50); // checks every 50ms

    // Stop trying after 5 seconds in case of error
    setTimeout(() => clearInterval(interval), 5000);
  }
});

// Add instagram 'inapp' class to document
document.addEventListener('DOMContentLoaded', function() {
  if (navigator.userAgent.toLowerCase().includes('instagram')) {
    document.documentElement.classList.add('inapp');
  }
});



(function() {
  function calcSavings() {
    const items = document.querySelectorAll('.cart__item');
    let totalSavings = 0;

    items.forEach(item => {
      const priceEl = item.querySelector('ins .money');
      const compareEl = item.querySelector('del .money');
      const qtyEl = item.querySelector('input.cart__quantity-field');

      if (priceEl && compareEl && qtyEl) {
        const price = parseFloat(priceEl.textContent.replace(/[^\d.]/g, ''));
        const compare = parseFloat(compareEl.textContent.replace(/[^\d.]/g, ''));
        const qty = parseInt(qtyEl.value, 10) || 1;

        totalSavings += (compare - price) * qty;
      }
    });

    const container = document.getElementById('cart-savings');
    if (!container) return;

    const priceSpan = container.querySelector('.cart__total__price .money');
    if (totalSavings > 0) {
      container.style.display = 'flex';
      if (priceSpan) {
        priceSpan.textContent = '$' + totalSavings.toFixed(2);
      }
    } else {
      container.style.display = 'none';
    }
  }

  // Initial calculation
  document.addEventListener('DOMContentLoaded', calcSavings);

  // Observe cart changes
  const cartContainer = document.querySelector('.drawer__items, .cart__price__holder');
  if (cartContainer) {
    const observer = new MutationObserver(() => {
      calcSavings();
    });

    observer.observe(cartContainer, {
      childList: true,
      subtree: true
    });
  }

  // Optional: run after quantity changes or item removal
  const priceHolder = document.querySelector('.cart__price__holder');
  if (priceHolder) {
    priceHolder.addEventListener('change', calcSavings);
  }
})();


(function () {
  function setProductStickyVars() {
    // Only run on desktop
    if (window.innerWidth < 750) return;

    // Only run on product pages
    if (!document.body.classList.contains('template-product')) return;

    const content = document.querySelector('.product__page .form__wrapper.is-sticky');
    const header = document.querySelector('.theme__header');

    if (!content || !header) return;

    const headerHeight = header.offsetHeight;
    const contentHeight = content.offsetHeight;

    // Output CSS variables
    document.documentElement.style.setProperty(
      '--product-sticky-top',
      `${headerHeight}px`
    );

    document.documentElement.style.setProperty(
      '--product-sticky-height',
      `${contentHeight}px`
    );
  }

  window.addEventListener('load', setProductStickyVars);
})();

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.scroll-shadow-menu-links').forEach(el => {
    const drawer = el.closest('.drawer__menu'); // parent container to compare

    const updateScrollbarVisibility = () => {
      if (!drawer) return;

      // Show scrollbar if the container is smaller than the content
      if (el.scrollHeight > drawer.scrollHeight) {
        el.classList.remove('no-scroll'); // content overflows → show fake scrollbar
      } else {
        el.classList.add('no-scroll');    // content fits → hide scrollbar
      }
    };

    // Initial check
    updateScrollbarVisibility();

    // Update on resize (responsive)
    window.addEventListener('resize', updateScrollbarVisibility);
  });
});

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
